import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const useParentWidth = (ref) => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (ref.current) {
            const updateWidth = () => {
                const newWidth = ref.current.offsetWidth;
                setWidth(newWidth);
            };

            const debouncedUpdateWidth = debounce(updateWidth, 50); // exécute updateWidth après 100ms depuis le dernier appel

            updateWidth(); // Set initial width immediately

            window.addEventListener('resize', debouncedUpdateWidth);

            // Cleanup
            return () => window.removeEventListener('resize', debouncedUpdateWidth);
        }
    }, [ref]);

    return width;
};

export default useParentWidth;
